import { createSlice } from '@reduxjs/toolkit'
import dayjs from "dayjs"
const currentDate = new Date();
const today = dayjs();
export const commonSlice = createSlice({
    name: 'common',
    initialState: {
        navOpen: true,
        selectedMonth: currentDate.getMonth() + 1,
        selectedYear: currentDate.getFullYear(),
        selectedStartDate: today.subtract(1, "month").format("MM-YYYY"),
        selectedEndDate: today.format("MM-YYYY"),
    },
    reducers: {
        setNavOpen: (state, action) => {
            state.navOpen = action.payload
        },
        setSelectedMonthYear: (state, action) => {
            state.selectedMonth = action.payload.month
            state.selectedYear = action.payload.year
        },
        setSelectedStartDateEndDate: (state, action) => {
            state.selectedEndDate = action.payload.end_date
            state.selectedStartDate = action.payload.start_date
        },


    },
})

export const { setNavOpen, setSelectedMonthYear,setSelectedStartDateEndDate } = commonSlice.actions

export default commonSlice.reducer